<form class="flex col" autocomplete="nope" #form="ngForm">
    @for (rl1BoxGroup of rl1Boxes(); track rl1BoxGroup.title) {
        <ui-card>
            <div class="flex col">
                @if (rl1BoxGroup.title) {
                    <h3>
                        {{ rl1BoxGroup.title | translate }}
                    </h3>
                }
                @for (rl1Box of rl1BoxGroup.boxes; track rl1Box.id) {
                    @if (rl1Box.xmlNameCamel; as boxName) {
                        <label [id]="boxName">
                            {{
                                'payroll.taxForms.RL1.employee.boxDescriptionFormat'
                                    | translate: { code: rl1Box.boxNumber, description: rl1Box.description }
                            }}
                        </label>
                        <mat-form-field>
                            <input
                                type="text"
                                [(ngModel)]="rl1()[boxName]"
                                name="{{ boxName }}"
                                #field="ngModel"
                                matInput
                                [attr.aria-labelledby]="boxName"
                                [appBackendT4Errors]="rl1().errors[boxName]"
                            />
                            @if (field.invalid) {
                                <mat-error>{{ field.errors | formErrors }}</mat-error>
                            }
                        </mat-form-field>
                    }
                }
            </div>
        </ui-card>
    }
</form>
